__turbopack_context__.v({
  "bold": "_3BBuJa_bold",
  "header": "_3BBuJa_header",
  "modal": "_3BBuJa_modal",
  "modalButtons": "_3BBuJa_modalButtons",
  "modalContent": "_3BBuJa_modalContent",
  "topBar": "_3BBuJa_topBar",
});
